import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';
import { Button } from 'src/app/components/Button';
import { ButtonProps } from 'src/app/types/ButtonProps';

import { translations } from '../../../../locales/translations';

function ResetPasswordButton(props: ButtonProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        textAlign: 'right',
        marginTop: 32
      }}
    >
      <Button
        label={t(translations.forgottenPassword.button)}
        variant="plain"
        {...props}
      />
    </Box>
  );
}

export default ResetPasswordButton;
